import lozad from 'lozad'
import createGlBackground from './glBackground'
// import Lenis from 'lenis'
import momentumScroll from './momentumScroll'
import lazyvideos from './lazyvideos'

let isMobile = null
let timeoutInstance = null

// Lazy Load init
const observer = lozad()
observer.observe()

// Lenis
// const lenis = new Lenis({
//   autoRaf: true,
// });

// GLSL Init
if (document.getElementById('bg-effect')) {
  const glBg = createGlBackground()
  glBg.start()
}

// Home link scroll to top behavior
document.addEventListener('click', (e) => {
  const link = e.target.closest('a')
  if (!link) return

  const url = new URL(link.href, window.location.origin)
  const isHomePage = url.pathname === '/' && url.origin === window.location.origin
  const hasNoHash = !url.hash || url.hash === ''
  const onHomePage = window.location.pathname === '/' || window.location.pathname === ''

  if (isHomePage && hasNoHash && onHomePage) {
    e.preventDefault()
    window.scrollTo(0, 0)
    // Remove any hash from the URL
    history.replaceState(null, null, '/')
  }
})

// Scroll behavior init (enable/disable at breakpoint)
const scrollContainer = document.querySelector('[data-scroll]')

if (scrollContainer) {
  const berdineScroll = momentumScroll(scrollContainer)

  function handleResize () {
    if (window.innerWidth < 768 && (!isMobile || isMobile === null)) {
      isMobile = true
      berdineScroll.destroy()
    } else if (window.innerWidth >= 768 && (isMobile || isMobile === null)) {
      isMobile = false
      clearTimeout(timeoutInstance)
      timeoutInstance = setTimeout(() => { berdineScroll.init() }, 500)
    }
  }

  handleResize()
  window.addEventListener('resize', handleResize)
}